import type { Mesh, MeshLambertMaterial } from "three"
import type InwardPointedPlaneGeometry from "../../lib/three/objects/mesh/InwardPointedPlaneGeometry.class"
import createSharedCachedFactory from "../memo/createSharedCachedFactory"

export type WaterMeshList = Array<Mesh<InwardPointedPlaneGeometry, MeshLambertMaterial>>

export const useWaterMeshList = createSharedCachedFactory((): WaterMeshList => {
  return []
})
